import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Interview_ListAction } from '../../../Redux/action/Interview_ListAction';
import { FaEllipsisH, FaEye } from 'react-icons/fa';
import Pagination from '../../Common/Pagination/Pagination';
import { Spinner } from 'react-bootstrap';
import { IoSearch } from 'react-icons/io5';
import Select from "react-select";
import { FiFilter } from 'react-icons/fi';
import { fetchDesignationDetails } from '../../../Redux/action/MasterSkillAction';

const InterviewPage = () => {
    const dispatch = useDispatch()
    const { search } = useLocation()
    const navigate = useNavigate();
    const location = useLocation();
    const [searchValue, setSearchValue] = useState('')
    const [filterActive, setFilterActive] = useState('ALL');
    const [selectedJobPosition, setSelectedJobPosition] = useState();
    const [jobPositionSendapi, setJobPositionSendAPI] = useState("");
    const currentTab = new URLSearchParams(search).get('active')?.toUpperCase();
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(7);

    const [activeTab, setActiveTab] = useState(currentTab ?? "SCHEDULED");
    // console.log("Tab==================",currentTab);  
    const AllDesignationList = useSelector(
        (state) => state?.MasterTableDetails?.designation?.content
    );
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
    const handleJobPositionChange = (selectedOptions) => {
        setSelectedJobPosition(selectedOptions);
        setJobPositionSendAPI(selectedOptions?.value);
    };
    const loader = useSelector((state) => state?.InterviewDashboard?.loading)
    const interviewList = useSelector((state) => state?.InterviewDashboard?.result?.content)
    const totalPages = useSelector((state) => state?.InterviewDashboard?.result?.totalPages)

    // console.log("interview...",interviewList)
    const admin = location.pathname.includes('admin');

    useEffect(() => {
        setPageNumber(0);
    }, [activeTab])

    useEffect(() => {
        dispatch(Interview_ListAction({ status: activeTab, pageNumber, pageSize, admin, jobPositionSendapi, searchValue, filterActive }))
    }, [activeTab, pageNumber, jobPositionSendapi, searchValue, filterActive])

    const [showOptionsForId, setShowOptionsForId] = useState(null); // State to track which row's options are shown
    const optionsRef = useRef(null);

    const toggleOptions = (id) => {
        setShowOptionsForId(showOptionsForId === id ? null : id);
    };


    const handlePageChange = (page) => {
        setPageNumber(page);
    };

    useEffect(() => {
        dispatch(fetchDesignationDetails());
        // Function to handle clicks outside the options menu
        const handleClickOutside = (event) => {
            if (optionsRef.current && !optionsRef.current.contains(event.target)) {
                setShowOptionsForId(null); // Close options menu if clicked outside
            }
        };

        // Add event listener to handle clicks outside the menu
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    function formatTabName(activeTab) {
        if (!activeTab) return '';
        return activeTab.charAt(0).toUpperCase() + activeTab.slice(1).toLowerCase();
    }

    const designationOptions = AllDesignationList?.map((item) => ({
        value: item?.designation,
        label: item?.designation,
    }));

    return (
        <div style={{ backgroundColor: '#f6f9ff', height: '100%', paddingTop: '20px' }}>
            <div className='common_wrapper mb-4 d-flex justify-content-between align-items-center' style={{ fontSize: '14px', width: '95%', backgroundColor: 'white' }}>
                <ul className="nav nav-pills justify-content-start">
                    <li className="nav-item">
                        <Link to={`/admin/interview?active=scheduled`}><button className={`nav-link ${activeTab === "SCHEDULED" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("SCHEDULED")}>Schedule Interview</button></Link>
                    </li>
                    <li className="nav-item">
                        <Link to={`/admin/interview?active=cancelled`}><button className={`nav-link  ${activeTab === "CANCELLED" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("CANCELLED")}>Cancelled Interview</button></Link>
                    </li>
                    <li className="nav-item">
                        <Link to={`/admin/interview?active=completed`}><button className={`nav-link  ${activeTab === "COMPLETED" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("COMPLETED")}>Completed Interview</button></Link>
                    </li>
                </ul>
            </div>
            <div className='common_wrapper'
                style={{ width: '95%', backgroundColor: 'white' }}>
                <div>
                    <div className="">
                        <div className="card-header common_table_header" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                            <div className="">
                            {`${formatTabName(activeTab)} Interview `}
                        </div>
                            <div className='d-flex flex-column flex-xl-row flex-wrap gap-2'>
                                <div style={{ width: '250px' }}>
                                    <Select
                                        options={[
                                            { value: "", label: "Select Job Position" }, // default first option
                                            ...(designationOptions || []),
                                        ]}
                                        isMulti={false}
                                        onChange={handleJobPositionChange}
                                        placeholder="Select Job Position"
                                        value={selectedJobPosition}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? "#286a94" : "#ccc",
                                                boxShadow: state.isFocused ? "0 0 0 1px #286a94" : "none",
                                                "&:hover": { borderColor: "#286a94" },
                                                minHeight: "25px",
                                                fontSize: "11px", // affects input text
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "10px",   // dropdown options font size
                                                padding: "6px 8px",
                                                backgroundColor: state.isSelected
                                                    ? "#286a94"
                                                    : state.isFocused
                                                        ? "#e6f2fa"
                                                        : "white",
                                                color: state.isSelected ? "white" : "#333",
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: "#e6f2fa",
                                                borderRadius: "8px",
                                                padding: "0px 0px",
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                fontSize: "11px",   // selected tag label font size
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: "11px",   // for single select case
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                color: "#777",
                                                fontSize: "11px",
                                            }),
                                        }}
                                    />
                                </div>
                                <div className='d-flex flex-wrap gap-2'>
                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                        <FiFilter style={{ position: 'absolute', top: '22px', left: '8px', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
                                        <select
                                            style={{
                                                padding: '7px 12px 7px 32px', // Padding adjusted to make space for the icon
                                                borderRadius: '4px',
                                                fontSize: '16px',
                                                border: '1px solid #e2e8f0',
                                                appearance: 'none' // This hides the default dropdown arrow
                                            }}
                                            id='select'
                                            value={filterActive}
                                            onChange={(e) => setFilterActive(e.target.value)}
                                        >
                                            <option value='ALL'>All</option>
                                            <option value='HR'>HR</option>
                                            <option value='TECHNICAL'>TECHNICAL</option>
                                        </select>
                                    </div>
                                    <div style={{ width: '13rem', height: '40px', backgroundColor: 'white', borderRadius: '0.275rem', display: 'flex', border: '1px solid #eee6e4' }}>
                                        <div style={{ width: '2rem', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <IoSearch style={{ color: '#286A94', fontSize: '1.25rem' }} />
                                        </div>
                                        <input
                                            className="small-placeholder"
                                            style={{ width: '100%', height: '66.67%', margin: 'auto 0', paddingLeft: '0.5rem', outline: 'none', border: 'none' }}
                                            placeholder="Search by candidate"
                                            type="text"
                                            value={searchValue}
                                            onChange={(e) => setSearchValue(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ paddingBottom: '30px' }} className="card-body table-responsive">
                            <table className="table-data" style={{ width: '100%', textAlign: 'center', fontSize: '14px', overflowX: 'auto', minWidth: '64rem' }}>
                                <thead>
                                    <tr>
                                        <th className='fw_500' scope="col">Interview Type</th>
                                        <th className='fw_500' scope="col">Hiring Company</th>
                                        <th className='fw_500' scope="col">Provider Company</th>
                                        <th className='fw_500' scope="col">Job Position</th>
                                        <th className='fw_500' scope="col">Interview Round</th>
                                        <th className='fw_500' scope="col">Candidate Name </th>
                                        <th className='fw_500' scope="col">Date</th>
                                        <th className='fw_500' scope="col">Time </th>
                                        <th className='fw_500' scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        loader ? <tr>
                                            <td colSpan="8" className="text-center">
                                                <div style={{ padding: '20px' }}>
                                                    <Spinner style={{ color: '#286a94' }} />
                                                </div>
                                            </td>
                                        </tr> : <>
                                            {interviewList && interviewList?.map((item, i) => {
                                                return (
                                                    <>
                                                        <tr key={i} className='text-start'>
                                                            <td>{item.inteviewType === 'TECHNICAL' ? item.inteviewType  : item.inteviewType}</td>
                                                            <td>{item.interviewerCompanyName || 'N/A'}</td>
                                                            <td>{item.candidateCompanyName || 'N/A'}</td>
                                                            <td>{item?.jobPosition}</td>
                                                            <td>{item.round}</td>
                                                            <td>{item?.candidateName}</td>
                                                            <td>{item?.interviewDate.split(" ")[0]}</td>
                                                            <td>{item.interviewStartTime}</td>
                                                            <td>
                                                                <div
                                                                    onClick={() => navigate("/admin/interview/interviews_info"+`/${item?.interviewId}`)}
                                                                >
                                                                    <FaEye style={{ cursor: "pointer", fontSize: "1.125rem", margin: "0 auto" }} />
                                                                </div>
                                                                {/* <div style={{ position: "relative" }}>
                                                                    <FaEllipsisH
                                                                        onClick={() => toggleOptions(item?.interviewId)}
                                                                        style={{ cursor: "pointer", margin: "0 1rem" }}
                                                                    />
                                                                    {showOptionsForId === item?.interviewId && (
                                                                        <div
                                                                            style={{
                                                                                position: "absolute",
                                                                                backgroundColor: "white",
                                                                                border: "1px solid #e5e7eb",
                                                                                borderRadius: "0.125rem",
                                                                                marginTop: "0.25rem",
                                                                                width: "6rem",
                                                                                right: 0,
                                                                                zIndex: 10,
                                                                            }}
                                                                            ref={optionsRef}
                                                                        >
                                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                                                    <div
                                                                                        style={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            margin: "0 auto",
                                                                                            padding: "0.25rem 0.5rem",
                                                                                            width: "100%",
                                                                                            borderBottom: "1px solid #e5e7eb",
                                                                                            cursor: "pointer",
                                                                                            ':hover': { backgroundColor: "#f1f5f9" }
                                                                                        }}
                                                                                        onClick={() => navigate("/admin/interview/interviews_info", { state: { dataToSend: item?.interviewId } })}
                                                                                    >
                                                                                        <p style={{ margin: "0 auto" }}>View</p>
                                                                                        <FaEye style={{ cursor: "pointer", fontSize: "1.125rem", margin: "0 auto" }} />
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div> */}
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })}</>
                                    }

                                </tbody>
                            </table>
                            {interviewList?.length === 0 && (
                                <div className="text-center mt-4">
                                    <h5 style={{ fontSize: '14px' }}>No Data Found</h5>
                                </div>
                            )}
                        </div>
                    </div>
                    {interviewList?.length >= 1 ? (
                        <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
                    ) : (
                        ""
                    )}
                </div>

            </div>
        </div>
    )
}

export default InterviewPage;

